import React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { setUserCredential, setUserProfile } from '@app/state/actions';
import { CUSTOMER, PROFESSIONAL } from '@app/constants/userTypes';
import * as paths from '@app/constants/paths';
// nodejs library that concatenates classes
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import Card from "@app/components/Card/Card";
import CardBody from "@app/components/Card/CardBody";
import Button from "@app/components/CustomButtons/Button";
import CustomLinearProgress from "@app/components/CustomLinearProgress/CustomLinearProgress";

import style from "@app/assets/jss/material-kit-pro-react/views/componentsSections/sectionCards";

function Options(props) {
    const { classes } = props;


    const service = props.userProfile && props.userProfile.service ? props.userProfile.service : 'service.undefined';
    const serviceColor = props.userProfile && props.userProfile.service ? 'success' : 'danger';
    const serviceValue = props.userProfile && props.userProfile.service ? 100 : 0;

    return (
        <div className={classes.container}>
            <GridContainer>
                <GridItem xs={12}>
                    <h3 className={classes.textCenterBlack}>
                        <b>ONLINE</b>
                    </h3>
                </GridItem>
                {props.userProfile.userType === PROFESSIONAL &&
                    <GridItem xs={12} sm={6}>
                        <Card raised>
                            <CardBody textCenter>
                                {
                                    serviceValue == 100 ?
                                        (
                                            <div className={classes.stats + " " + classes.mlAuto + " " + classes.justifyContentRight + " " + classes.iconComplete}>
                                                <i class="fas fa-check">
                                                    {serviceValue}&#37;
                                                </i>
                                            </div>
                                        )
                                        :
                                        (
                                            <div className={classes.stats + " " + classes.mlAuto + " " + classes.justifyContentRight + " " + classes.iconNotComplete}>
                                                <i class="fas fa-check">
                                                    {serviceValue}&#37;
                                                </i>
                                            </div>
                                        )
                                }
                                <h3 className={classes.cardCategorySocial}>
                                    <i class="fas fa-envelope-open-text" /> Service
                                </h3>
                                <h4 className={classes.cardTitle}>
                                    <FormattedMessage id={service} />
                                </h4>
                                <CustomLinearProgress
                                    variant="determinate"
                                    color={serviceColor}
                                    value={serviceValue}
                                />
                                <Button to={paths.USER_PROFILE + '?step=2'} color="danger" component={Link} round >
                                    Edit
                                </Button>
                            </CardBody>
                        </Card>
                    </GridItem>
                }
                <GridItem xs={12} sm={6}>
                    <Card raised>
                        <CardBody textCenter>
                            <h3 className={classes.cardCategorySocial}>
                                <i className="fas fa-file-signature" /> Contact Details
                            </h3>
                            <h4 className={classes.cardTitle}>
                                Email, Telephone etc.
                            </h4>
                            <CustomLinearProgress
                                variant="determinate"
                                color="primary"
                                value={90}
                            />
                            <Button to={paths.USER_PROFILE + '?step=1'} color="danger" component={Link} round>
                                Edit
                            </Button>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6}>
                    <Card raised>
                        <CardBody textCenter>
                            <h3 className={classes.cardCategorySocial}>
                                <i className="fas fa-share-alt" /> Socials
                            </h3>
                            <h4 className={classes.cardTitle}>
                                Facebook, Twitter & the like.
                            </h4>
                            <CustomLinearProgress
                                variant="determinate"
                                color="primary"
                                value={90}
                            />
                            <Button to={paths.USER_PROFILE + '?step=8'} color="danger" component={Link} round>
                                Edit
                            </Button>
                        </CardBody>
                    </Card>
                </GridItem>
                {props.userProfile.userType === PROFESSIONAL &&
                    <GridItem xs={12} sm={6}>
                        <Card raised>
                            <CardBody textCenter>
                                <h3 className={classes.cardCategorySocial}>
                                    <i className="fas fa-globe" /> Website
                                </h3>
                                <h4 className={classes.cardTitle}>
                                    You have a website?
                                </h4>
                                <CustomLinearProgress
                                    variant="determinate"
                                    color="primary"
                                    value={90}
                                />
                                <Button to={paths.USER_PROFILE + '?step=8'} color="danger" component={Link} round>
                                    Edit
                                </Button>
                            </CardBody>
                        </Card>
                    </GridItem>
                }
                <GridItem xs={12} sm={6}>
                    <Card raised>
                        <CardBody textCenter>
                            <h3 className={classes.cardCategorySocial}>
                                <i className="fas fa-sign-in-alt" /> Login Details
                            </h3>
                            <h4 className={classes.cardTitle}>
                                Update your login options.
                            </h4>
                            <CustomLinearProgress
                                variant="determinate"
                                color="primary"
                                value={90}
                            />
                            <Button to={paths.USER_PROFILE + '?step=0'} color="danger" component={Link} round>
                                Edit
                            </Button>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6}>
                    <Card raised>
                        <CardBody textCenter>
                            <h3 className={classes.cardCategorySocial}>
                                <i class="fas fa-id-card" /> Data
                            </h3>
                            <h4 className={classes.cardTitle}>
                                Your personal data.
                            </h4>
                            <CustomLinearProgress
                                variant="determinate"
                                color="primary"
                                value={90}
                            />
                            <Button type="button" disabled={props.isLoading} color="danger" onClick={props.sendGdprUserEmail}>
                                <FormattedMessage id="get.gdpr.report" />
                            </Button>
                        </CardBody>
                    </Card>
                </GridItem>
                {props.userProfile.userType === PROFESSIONAL &&
                    <React.Fragment>
                        <GridItem xs={12}>
                            <h3 className={classes.textCenterBlack}>
                                <b>BUSINESS</b>
                            </h3>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i className="fas fa-hand-spock" /> Services
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        Set your main services.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button to={paths.USER_PROFILE + '?step=2'} color="danger" component={Link} round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i class="fas fa-calendar-alt" /> Scheduling
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        Set your schedule.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button to={paths.CALENDAR} color="danger" component={Link} round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i className="fas fa-graduation-cap" /> Accrediations
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        Show what you know.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button to={paths.USER_PROFILE + '?step=4'} color="danger" component={Link} round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i className="fas fa-house-damage" /> Indemnities
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        Show you're covered.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button to={paths.USER_PROFILE + '?step=5'} color="danger" component={Link} round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i className="fas fa-users" /> Team Profiles
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        Show off your crew.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button to={paths.USER_PROFILE + '?step=6'} color="danger" component={Link} round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i className="fas fa-images" /> Work Gallery
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        Show off your skills.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button to={paths.USER_PROFILE + '?step=7'} color="danger" component={Link} round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12}>
                            <h3 className={classes.textCenterBlack}>
                                <b>ENTERPRISE</b>
                            </h3>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i class="fas fa-receipt" /> Invoicing
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        See your invoices.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button color="danger" round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i class="far fa-credit-card" /> Payments
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        See your payments.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button color="danger" round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i class="fas fa-search-plus" /> Networks
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        See your search networks.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button color="danger" round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i class="fab fa-searchengin">Keywords</i>
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        Set your search terms.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button color="danger" round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12}>
                            <h3 className={classes.textCenterBlack}>
                                <b>ADD-ONS</b>
                            </h3>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i class="fab fa-html5" /> DOMAIN
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        Manage your domain.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button color="danger" round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i class="fas fa-user-plus" /> LEADS
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        See your leads.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button color="danger" round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i class="fas fa-ad" /> EZ Ads
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        See your ads.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button color="danger" round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                            <Card raised>
                                <CardBody textCenter>
                                    <h3 className={classes.cardCategorySocial}>
                                        <i class="fas fa-robot" /> Social AI
                                    </h3>
                                    <h4 className={classes.cardTitle}>
                                        See your social bots.
                                    </h4>
                                    <CustomLinearProgress
                                        variant="determinate"
                                        color="primary"
                                        value={90}
                                    />
                                    <Button color="danger" round>
                                        Edit
                                    </Button>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </React.Fragment>
                }
            </GridContainer>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        userProfile: state.authentication.userProfile
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setUserCredential: userCredential => dispatch(setUserCredential(userCredential)),
        setUserProfile: userProfile => dispatch(setUserProfile(userProfile))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withStyles(style)(Options)));